var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGridAdd = function SvgGridAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.099 7.366H3.564A1.27 1.27 0 0 1 2.297 6.1V3.564a1.27 1.27 0 0 1 1.267-1.267H6.1a1.27 1.27 0 0 1 1.267 1.267V6.1A1.27 1.27 0 0 1 6.1 7.366m-2.823-4.09v3.108h3.108V3.276zM12.436 7.366H9.9A1.27 1.27 0 0 1 8.634 6.1V3.564A1.27 1.27 0 0 1 9.9 2.297h2.535a1.27 1.27 0 0 1 1.267 1.267V6.1a1.27 1.27 0 0 1-1.267 1.267m-2.823-4.09v3.108h3.108V3.276zM6.099 13.703H3.564a1.27 1.27 0 0 1-1.267-1.267V9.9a1.27 1.27 0 0 1 1.267-1.267H6.1A1.27 1.27 0 0 1 7.366 9.9v2.535A1.27 1.27 0 0 1 6.1 13.703m-2.823-4.09v3.108h3.108V9.613z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.638 11.169c0-.263.212-.476.475-.476h4.12a.475.475 0 1 1 0 .95h-4.12a.475.475 0 0 1-.475-.474",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.173 13.704a.475.475 0 0 1-.476-.475v-4.12a.475.475 0 1 1 .95 0v4.12a.475.475 0 0 1-.475.475",
    clipRule: "evenodd"
  })));
};
export { SvgGridAdd as ReactComponent };
export default __webpack_public_path__ + "8b9422636219408626fb19bd4e5f502b.svg";